import actionsTypes from './actionTypes';
import {
  IChangePropertyExtendedPayload,
  IAddBankAccountRequestPayload,
  IProcessRequestPayload,
  ILoadDataRequestPayload,
  ILoadFormDataSuccessPayload,
  ISetupIntentBankAccountSuccessPayload,
  ISetupIntentBankAccountRequestPayload,
  IConfirmBankAccountAddedPayload,
} from './types';
import {
  ChangePropertyAction,
  AddBankAccountRequestAction,
  AddBankAccountErrorAction,
  AddBankAccountSuccessAction,
  ChangeModalVisibilityAction,
  ProcessActionRequestAction,
  LoadFormInfoRequestAction,
  LoadFormInfoSuccessAction,
  LoadFormInfoErrorAction,
  ConfirmBankAddedAction,
  setupIntentBankAccountSuccessAction,
  setupIntentBankAccountRequestAction,
} from './actions.d';

const actions = {
  changeProperty: (payload: IChangePropertyExtendedPayload): ChangePropertyAction => ({
    type: actionsTypes.CHANGE_PROPERTY,
    payload,
  }),

  addBankAccountRequest: <T1, T2>(
    payload: IAddBankAccountRequestPayload<T1, T2>,
  ): AddBankAccountRequestAction<T1, T2> => ({
    type: actionsTypes.ADD_BANK_ACCOUNT_REQUEST,
    payload,
  }),

  addBankAccountSuccess: (): AddBankAccountSuccessAction => ({
    type: actionsTypes.ADD_BANK_ACCOUNT_SUCCESS,
  }),

  addBankAccountError: (): AddBankAccountErrorAction => ({
    type: actionsTypes.ADD_BANK_ACCOUNT_ERROR,
  }),

  processActionRequest: <T1, T2>(payload: IProcessRequestPayload<T1, T2>): ProcessActionRequestAction<T1, T2> => ({
    type: actionsTypes.PROCESS_ACTION_REQUEST,
    payload,
  }),

  changeModalVisibility: (): ChangeModalVisibilityAction => ({
    type: actionsTypes.CHANGE_MODAL_VISIBILITY,
  }),

  loadFormInfoRequest: <T1, T2>(payload: ILoadDataRequestPayload<T1, T2>): LoadFormInfoRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_FORM_INFO_REQUEST,
    payload,
  }),

  loadFormInfoSuccess: (payload: ILoadFormDataSuccessPayload): LoadFormInfoSuccessAction => ({
    type: actionsTypes.LOAD_FORM_INFO_SUCCESS,
    payload,
  }),

  loadFormInfoError: (): LoadFormInfoErrorAction => ({
    type: actionsTypes.LOAD_FORM_INFO_ERROR,
  }),

  confirmBankAddedRequest: (payload: IConfirmBankAccountAddedPayload): ConfirmBankAddedAction => ({
    type: actionsTypes.CONFIRM_BANK_ADDED_REQUEST,
    payload,
  }),

  setupIntentBankAccountRequest: (
    payload: ISetupIntentBankAccountRequestPayload,
  ): setupIntentBankAccountRequestAction => ({
    type: actionsTypes.SETUP_INTENT_BANK_ACCOUNT_REQUEST,
    payload,
  }),

  setupIntentBankAccountSuccess: (
    payload: ISetupIntentBankAccountSuccessPayload,
  ): setupIntentBankAccountSuccessAction => ({
    type: actionsTypes.SETUP_INTENT_BANK_ACCOUNT_SUCCESS,
    payload,
  }),
};

export default actions;
